// The base half of the per-worktree routing tripwire — the sibling of
// `hub-binding.ts`, over the same machinery in `worktree-binding.ts`. Separate
// files on disk is deliberate: a worktree may legitimately be bound to one hub
// AND one base (docs/reference/rekor-platform-contracts.md §3.3).

import { PATH_SAFE_ID_RULE, isPathSafeId } from './base-id.js';
import { createWorktreeBinding } from './worktree-binding.js';

const binding = createWorktreeBinding({
  filename: 'wayai-base-binding',
  // `isPathSafeId`, not the API's base-id rule. The tripwire's duty is that a
  // garbled or multi-line file read as unbound, which this grammar delivers;
  // applying the mint rule instead would refuse to bind a base whose stored id
  // predates it — a base the API still serves — and so lock the CLI out of the
  // one workflow that could migrate off it.
  isValidId: isPathSafeId,
  noun: 'base',
  // States what is actually checked. "must be a slug" described no rule the
  // reader could act on, and naming the API's rule here would name the wrong one.
  idLabel: `base id (${PATH_SAFE_ID_RULE})`,
  unbindCommand: 'wayai bases unbind',
  useCommand: 'wayai bases use',
});

export const getBaseBindingPath = binding.getBindingPath;
export const readBaseBinding = binding.readBinding;
export const writeBaseBinding = binding.writeBinding;
export const clearBaseBinding = binding.clearBinding;
export const autoBindBaseIfUnbound = binding.autoBindIfUnbound;
export const assertBaseMatchesBinding = binding.assertMatchesBinding;
export const assertNoBindingBlocksBaseCreation = binding.assertNoBindingBlocksCreation;
